module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/yandex-ok/4.png?8631c822fdeb5d7f593a78a81cc44e28";